export const useCommonStore = defineStore('common', () => {
  const userId = ref<string>('')

  const setUserId = (value: string) => {
    userId.value = value
  }

  return { userId, setUserId }
})
